import AppLogoLinearImg from './../../assets/img/linearLogoGreen.svg' // assicurati che il path sia corretto
import { Blob1, Blob2, LogoContainer, LogoLinear, ShapeBase, SplashScreenLinear } from "../../components/styled/LinearSplash.style";

interface SplashScreenPageProps {
    className?: string
}

const SplashScreenPageLinear = ({ className }: SplashScreenPageProps) => {
  return (
    <SplashScreenLinear className={className}>
      <ShapeBase
        animate={{ rotate: 360 }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        <Blob1 />
      </ShapeBase>

      <ShapeBase
        animate={{ rotate: -360 }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        <Blob2 />
      </ShapeBase>

      <LogoContainer
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <LogoLinear src={AppLogoLinearImg} alt="Linear Logo" />
      </LogoContainer>
    </SplashScreenLinear>
  );
};

export default SplashScreenPageLinear;
